import { render } from "./BarraLateral.vue?vue&type=template&id=579216d0&scoped=true"
import script from "./BarraLateral.vue?vue&type=script&lang=ts"
export * from "./BarraLateral.vue?vue&type=script&lang=ts"

import "./BarraLateral.vue?vue&type=style&index=0&id=579216d0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-579216d0"

export default script